import { Stack } from '@mui/material';

import { ReplyResponse } from '@/api/endpoints/community/posts/useGetReplies';

import { ReplyFormData } from './ReplyForm';
import { ReplyItem } from './ReplyItem';

interface ReplyThreadProps {
  replies: ReplyResponse[];
  onReply: (data: ReplyFormData) => Promise<void>;
  onEdit?: (replyId: number, data: ReplyFormData) => Promise<void>;
  onDelete?: (replyId: number) => Promise<void>;
  onToggleLike?: (replyId: number) => Promise<void>;
  isUserMember?: boolean;
  isUserAdmin?: boolean;
  level?: number;
  maxLevel?: number;
}

// ReplyThread component - using function declaration for hoisting
export const ReplyThread = ({
  replies,
  onReply,
  onEdit,
  onDelete,
  onToggleLike,
  isUserMember = false,
  isUserAdmin = false,
  level = 0,
  maxLevel = 3,
}: ReplyThreadProps): JSX.Element => (
  <Stack spacing={level > 0 ? 1 : 0}>
    {replies.map(reply => (
      <ReplyItem
        key={reply.id}
        reply={reply}
        onReply={onReply}
        onEdit={onEdit}
        onDelete={onDelete}
        onToggleLike={onToggleLike}
        isUserMember={isUserMember}
        isUserAdmin={isUserAdmin}
        level={level}
        maxLevel={maxLevel}
      />
    ))}
  </Stack>
);
